import de from "./de.json";
import en from "./en.json";

export const taxRegistrationTranslations = { de, en };
